// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".transcation-dialog.common-dialog[data-v-680454a4] .el-dialog{width:var(--common-dialog-medium-width)}.transcation-dialog.common-dialog .el-form[data-v-680454a4]{margin-right:var(--common-dialog-form-margin-right)}.transcation-dialog.common-dialog .el-select[data-v-680454a4]{width:100%}", ""]);
// Exports
module.exports = exports;
